import styled from '@emotion/styled';
import React from 'react';

import glyphStyles from '../../../components/common/Glyph.module.css';
import { su, suPx } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';
import { TextSmall } from '../../../components/common/text/TextSmall';
import { Tooltip } from '../../../components/common/tooltip/Tooltip';

export function FlowCardHint(props) {
  return (
    <Tooltip
      offset={suPx(2)}
      delay={200}
      placement="top"
      isDisabled={props.isDisabled}
      renderTrigger={(triggerRef, triggerProps) => {
        return (
          <FlowCardHint.Trigger
            {...triggerProps}
            ref={triggerRef}
            className={props.className}
            data-is-disabled={props.isDisabled}
          >
            {props.icon ?? (
              <FlowCardHint.IconWrapper data-is-highlight={props.isHighlightIcon}>
                <Glyph
                  source={props.iconUrl ?? glyph.core.infoCircleFill}
                  size="14px"
                  color={theme.icon.color_light}
                />
              </FlowCardHint.IconWrapper>
            )}
          </FlowCardHint.Trigger>
        );
      }}
    >
      <FlowCardHint.Text color={theme.color.text_light}>{props.hint}</FlowCardHint.Text>
    </Tooltip>
  );
}

FlowCardHint.Trigger = styled.div`
  display: block;
  flex: 0 0 auto;

  &[data-is-disabled='true'] {
    cursor: unset;
    pointer-events: none;
  }
`;

FlowCardHint.IconWrapper = styled.div`
  .${glyphStyles.root} {
    transition: color ${motion.duration.fast} ${motion.curve.ease_in_out};
  }

  &[data-is-highlight='true'] {
    .${glyphStyles.root} {
      color: ${theme.color.highlight};
    }
  }

  &:hover {
    .${glyphStyles.root} {
      color: ${theme.icon.color_light_hover};
    }
  }
`;

FlowCardHint.Text = styled(TextSmall)`
  width: 300px;
  padding: ${su(2)};
  word-break: break-word;
  // Supports /n in developer provided hints.
  white-space: pre-wrap;
`;
